import { when } from 'mobx';
import { inject } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { FamilySettingsConstants as ui } from '../../Config/UIConstants';
import { CommonTextInput } from '../../SharedComponents/CommonTextInput';
import { FullContainer } from '../../SharedComponents/FullContainer';
import { FullScreenModalContainer } from '../../SharedComponents/FullScreenModalContainer';
import { ModalActionButtonBar } from '../../SharedComponents/ModalActionButtonBar';
import { ApplicationStore } from '../../_stores/ApplicationStore';
import { largeShadow } from '../../styles/styleObjects';

interface IState {
    familyName: string;
}

interface IProps {
    store: ApplicationStore;
}

@inject('store')
export class FamilySettingsPage extends React.Component<RouteComponentProps<any> & IProps, IState> {
    private originalFamilyName = '';

    public state: IState = {
        familyName: ''
    };

    private onPressSave = (): void => {
        const family = this.props.store.userFamilyStore.getFamilyByID(parseInt(this.props.match.params.id));
        if (this.state.familyName.trim() !== family.name) {
            this.props.store.userFamilyStore.updateFamilyName(family.id, this.state.familyName);
        }

        this.props.history.push(`/familydetail/${parseInt(this.props.match.params.id)}`);
    }

    public componentDidMount(): void {
        when(
            () => this.props.store.userFamilyStore && this.props.store.userFamilyStore.familiesAreLoaded,
            () => {
                const family = this.props.store.userFamilyStore.getFamilyByID(parseInt(this.props.match.params.id));
                this.setState({ familyName: family.name });
                this.originalFamilyName = family.name;
            }
        );
    }

    public render() {
        return (
            <FullScreenModalContainer {...this.props} onPressExit={() => this.props.history.push(`/familydetail/${parseInt(this.props.match.params.id)}`)}>
                <FullContainer style={styles.container}>
                    <p style={styles.header}>{ui.FAMILY_SETTINGS}</p>
                    <CommonTextInput
                        header={ui.FAMILY_NAME}
                        onChangeText={text => this.setState({ familyName: text })}
                        value={this.state.familyName}
                        containerStyle={styles.input}
                        placeholder={ui.REQUIRED_PLACEHOLDER}
                    />
                </FullContainer>
                <ModalActionButtonBar
                    confirmOnClick={() => this.onPressSave()}
                    confirmContent={ui.SAVE}
                    altPadding={25}
                    confirmDisabled={this.originalFamilyName === this.state.familyName}
                />
            </FullScreenModalContainer>
        );
    }
}

const styles = {
    container: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center'
    } as React.CSSProperties,
    header: {
        fontSize: 25,
        color: '#423F4E',
        fontWeight: 900,
        marginTop: 70,
        height: 50
    } as React.CSSProperties,
    input: {
        width: 400,
        height: 75,
        backgroundColor: 'white',
        marginTop: 40,
        boxShadow: largeShadow
    }
};



// WEBPACK FOOTER //
// ./src/Pages/FamiliesPage/FamilySettingsPage.tsx